import { Form } from 'antd';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type ItemP = Omit<React.ComponentProps<typeof Form.Item>, 'label'> & {
  label?: string;
};

const FormItem: React.FC<ItemP> = ({ label, ...rest }) => {
  const { t } = useTranslation();

  return <Form.Item label={label ? t(label) : label} required={false} {...rest} />;
};

export default FormItem;
